import { useEffect } from 'react';

function useTitle(title, defaultTitle = 'Attendiau') {
  useEffect(() => {
    document.title = title ? `${defaultTitle} ${title} ` : defaultTitle;
  }, [title, defaultTitle]);
}

export default useTitle;
